<!-- This code has been partially generated by an AI. -->
<section class="flex flex-col items-center" (clickOutside)="showOptions = false">
  <button data-testid="profile-settings-btn" class="btn btn-circle hover:cursor-pointer" (click)="showOptions = true">
    <if-profile-picture [employee]="employee" [blockEmployeeSwitchDialog]="true" />
  </button>
  @if (showOptions) {
    <div class="relative w-full z-50">
      <div
        class="absolute right-0 min-w-min top-5 rounded-sm border border-grey-400 dark:border-grey-300 shadow-lvl1 dark:shadow-none bg-white dark:bg-grey-800 text-grey-600 dark:text-grey-200 float-right"
      >
        <div class="p-4 flex flex-col gap-2">
          <h3>Einstellungen</h3>
          <if-profile-picture-upload />
          <div>
            <span class="text-sm">Anmutung</span>
            <div class="flex gap-1">
              @if (themeService.theme(); as theme) {
                <!-- Light Theme -->
                <button
                  data-testid="light-theme-btn"
                  class="btn btn-square btn-xl flex flex-col items-center justify-center p-2"
                  [class.btn-active]="themeService.theme() === ThemeEnum.LIGHT"
                  (click)="themeService.theme.set(ThemeEnum.LIGHT)"
                >
                  <ng-icon name="heroSun" strokeWidth="2" size="20" />
                  <span class="text-xs">Hell</span>
                </button>

                <!-- Dark Theme -->
                <button
                  data-testid="dark-theme-btn"
                  class="btn btn-square btn-xl flex flex-col items-center justify-center p-2"
                  [class.btn-active]="themeService.theme() === ThemeEnum.DARK"
                  (click)="themeService.theme.set(ThemeEnum.DARK)"
                >
                  <ng-icon name="heroMoon" strokeWidth="2" size="20" />
                  <span class="text-xs">Dunkel</span>
                </button>

                <!-- System Theme -->
                <button
                  data-testid="system-theme-btn"
                  class="btn btn-square btn-xl flex flex-col items-center justify-center p-2"
                  [class.btn-active]="themeService.theme() === ThemeEnum.SYSTEM"
                  (click)="themeService.theme.set(ThemeEnum.SYSTEM)"
                >
                  <ng-icon name="heroTv" strokeWidth="2" size="20" />
                  <span class="text-xs">System</span>
                </button>
              }
            </div>
          </div>
        </div>
        <div class="w-full h-px bg-grey-400"></div>
        <div class="flex flex-col">
          <button class="btn justify-start" (click)="onVisibilityButtonClick()" data-testid="sichtbarkeitseinstellung-btn">
            Sichtbarkeitseinstellung
          </button>
          <button (click)="openFeedbackDialog()" class="btn justify-start">Feedback Formular</button>
          @if (adminSettingsPermission.authorized) {
            <a [routerLink]="'/admin-settings'" class="btn justify-start">Admin Einstellungen</a>
          }
          <button data-testid="user-logout-btn" class="btn justify-start" (click)="logout()">Ausloggen</button>
        </div>
      </div>
    </div>
  }
</section>
